

























































































































import { Component } from "vue-property-decorator";
import MagicValidator from "../../../magic/MagicValidator.vue";
import WidgetBase from "../WidgetBase";
import vueDesign from "vue-esign";
import { fetch, getCookie, getStorage } from "@szgc/plt-core-v2";

@Component({
  name: "SignatureWidget",
  components: { MagicValidator, vueDesign }
})
export default class SignatureWidget extends WidgetBase {
  private signColor: any = "#000";
  private signDesignShow: boolean = false;
  private signSet: any = {
    width: 160,
    height: 160
  };
  private previewSignShow: boolean = false;
  private signPreImage: any = null;
  private signWidth: number = 0;
  private signHeight: number = 0;
  private strokeWidth: number = 6;

  get url() {
    const prefix = getCookie("plt-api-route") || getStorage("plt-api-route") || "";
    const token = getCookie("SZGC-SHIRO-TOKEN") || getStorage("SZGC-SHIRO-TOKEN") || "";
    // let token;
    // if (localStorage.getItem('offline') && localStorage.getItem('offline') === "true") {
    // }
    return this.value
      ? prefix + JSON.parse(this.value).fileRelativePath + "?SZGC-SHIRO-TOKEN=" + (token || "")
      : "";
  }

  get strokeStyle() {
    return {
      width: this.strokeWidth + "px",
      height: this.strokeWidth + "px",
      backgroundColor: this.signColor
    };
  }

  opened() {
    this.$nextTick(() => {
      const rect = document.querySelector(".d-box")?.getClientRects()[0];
      this.signWidth = rect?.width ?? 0;
      this.signHeight = rect?.height ?? 0;
      this.$forceUpdate();
    });
  }

  clickHandler() {
    if (!this.value && !this.widget.readonly) {
      this.previewSignShow = true;
    }
  }

  changeColor(c: string) {
    this.signColor = c ?? "#000000";
  }

  get boxStyle() {
    return {
      width: this.widget.width + "px",
      height: this.widget.height + "px"
    };
  }

  /*保存签名*/
  async saveSign() {
    (this.$refs.szgcSignDesign as any)
      .generate()
      .then((res: any) => {
        this.signPreImage = res;
        let img: any = document.createElement("img");
        img.src = res;
        const { width, height } = this.getImgSize(res);
        const ratio = this.widget.width / this.widget.height;

        let canvasWidth: number, canvasHeight: number;

        if (height * ratio > width) {
          canvasHeight = height + 50;
          canvasWidth = canvasHeight * ratio;
        } else {
          canvasWidth = width + 50;
          canvasHeight = canvasWidth / ratio;
        }

        let canvas: any = document.createElement("canvas");
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;

        const ctx = canvas.getContext("2d", { willReadFrequently: true });
        if (ctx) {
          ctx.fillStyle = "#fff";
          ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        }

        img.onload = () => {
          ctx?.drawImage(img, (canvasWidth - width) / 2, (canvasHeight - height) / 2);

          fetch({
            url: "/api/appproc/system/signature/v2",
            method: "post",
            data: {
              base64: canvas.toDataURL()
            }
          })
            .then((res: any) => {
              img = null;
              canvas = null;

              if (res.success) {
                this.$message.success("保存签名成功");
                this.previewSignShow = false;
                this.value = JSON.stringify({
                  fileRelativePath: res.data.requestRelativeUri,
                  attId: res.data.attId
                });
                // this.getSigns();
              } else {
                this.$message.error("保存签名失败");
              }
            })
            .catch((error: any) => {
              this.$message.error("保存签名失败: " + error);
            });
        };
      })
      .catch(() => {
        //没有签名，点击生成图片时调用
        // this.widget.required && this.$message.error("未设置签名");
        this.value = "";
        this.previewSignShow = false;
      })
      .finally(() => {
        this.signColor = "#000000";
      });
  }

  getImgSize(base64: string) {
    //确认处理的是png格式的数据
    if (base64.substring(0, 22) === "data:image/png;base64,") {
      const data = base64.substring(22 + 20, 22 + 32);
      const base64Characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      const nums = [];
      for (const c of data) {
        nums.push(base64Characters.indexOf(c));
      }
      const bytes = [];
      for (let i = 0; i < nums.length; i += 4) {
        bytes.push((nums[i] << 2) + (nums[i + 1] >> 4));
        bytes.push(((nums[i + 1] & 15) << 4) + (nums[i + 2] >> 2));
        bytes.push(((nums[i + 2] & 3) << 6) + nums[i + 3]);
      }
      const width = (bytes[1] << 24) + (bytes[2] << 16) + (bytes[3] << 8) + bytes[4];
      const height = (bytes[5] << 24) + (bytes[6] << 16) + (bytes[7] << 8) + bytes[8];
      return {
        width,
        height
      };
    }
    throw Error("unsupported image type");
  }
}
